"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enhanceFormControl;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function enhanceFormControl(Input) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(EnhancedInput, _React$Component);

    function EnhancedInput() {
      _classCallCheck(this, EnhancedInput);

      return _possibleConstructorReturn(this, _getPrototypeOf(EnhancedInput).apply(this, arguments));
    }

    _createClass(EnhancedInput, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
        var form = this.context.form;
        var shouldUpdate = !(0, _utils.shallowEqual)(nextProps, this.props) || !(0, _utils.shallowEqual)(nextState, this.state);

        if (!form || shouldUpdate) {
          return shouldUpdate;
        } else {
          var _this$_getField = this._getField(),
              value = _this$_getField.value,
              error = _this$_getField.error;

          var _this$_getField2 = this._getField(nextContext),
              nextValue = _this$_getField2.value,
              nextError = _this$_getField2.error;

          return value !== nextValue || error !== nextError;
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var form = this.context.form;
        var _this$props = this.props,
            validation = _this$props.validation,
            name = _this$props.name;

        if (form && validation) {
          var subscribeToOnSubmit = form.subscribeToOnSubmit;
          subscribeToOnSubmit(name, validation);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var form = this.context.form;
        var _this$props2 = this.props,
            validation = _this$props2.validation,
            name = _this$props2.name;

        if (form && validation) {
          var unsubscribeToOnSubmit = form.unsubscribeToOnSubmit;
          unsubscribeToOnSubmit(name);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            name = _this$props3.name,
            onChange = _this$props3.onChange,
            validation = _this$props3.validation;
        var form = this.context.form;

        if (!form || !name) {
          return _react.default.createElement(Input, _objectSpread({}, this.props));
        }

        var onChangeField = form.onChangeField;

        var _this$_getField3 = this._getField(),
            value = _this$_getField3.value,
            error = _this$_getField3.error;

        return _react.default.createElement(Input, _objectSpread({
          value: value != null ? value : ''
        }, (0, _omit.default)(this.props, ['validation']), {
          error: error,
          onChange: onChange ? function (value, name) {
            return onChange(value, name, onChangeField);
          } : onChangeField
        }));
      }
    }, {
      key: "_getField",
      value: function _getField(context) {
        var _ref = context ? context : this.context,
            form = _ref.form;

        var name = this.props.name;
        var values = form.values,
            errors = form.errors;
        var value = (0, _get.default)(values, name);
        var error = (0, _get.default)(errors, name);
        return {
          value: value,
          error: error
        };
      }
    }]);

    return EnhancedInput;
  }(_react.default.Component), _defineProperty(_class, "contextTypes", {
    form: _propTypes.default.shape({
      values: _propTypes.default.object,
      errors: _propTypes.default.object,
      onChangeField: _propTypes.default.func,
      subscribeToOnSubmit: _propTypes.default.func,
      unsubscribeToOnSubmit: _propTypes.default.func
    })
  }), _temp;
}